import { useContext, useEffect, useState } from 'react';
import { APP_KEY_IDS, FILE_EXPLORER_CONTENT_TYPE } from '../../constants/constants';
import BaseAppContainer from '../base--app-container/BaseAppContainer';
import LeftPanelMenu from '../left-panel-menu/LeftPanelMenu';
import Styles from './FileExplorer.module.scss';
import ContentBox from './content-box/ContentBox';
import { FolderContentType } from '../../types/types';
import { SPECIAL_ROUTE_HARACTER, getCurrentOption, gotoPreviousOption } from '../../global/functions/functrions';
import ContentDialog from '../dialog-content/ContentDialog';
import { MOBILE_DIRECTORIES, RESUME } from '../../constants/os/mobile/directory';
import { DIRECTORIES } from '../../constants/os/desktop/directory';
import { AppContext } from '../../contexts/AppContext';
import BaseMobileAppContainer from '../mobile/base-mobile-app-container/BaseMobileAppContainer';
import MobileOptionsList from '../mobile/mobile-options-list/MobileOptionsList';
import CategsIcon from "../../icons/common/file_manager_categs.webp"
import classnames from "classnames"


const FileExplorer = () => {

    const { isMobile } = useContext(AppContext)

    const [activeId, setActiveId] = useState(isMobile ? "" : "2")
    const [title, setTitle] = useState(isMobile ? "File Manager" : "Downloads")
    const [files, setFiles] = useState<FolderContentType[] | undefined>()

    const Directory = isMobile ? MOBILE_DIRECTORIES : DIRECTORIES

    const onTabClicked = (file: FolderContentType) => {
        setFiles(file.subOptions)
        setTitle(file.label)
    }

    const updateFiles = (id: string, files: FolderContentType[] | undefined, label: string) => {
        setActiveId(id)
        setTitle(label)
    }
    const [forwardRef, setForwardRef] = useState("")


    const onPreviousClick = async () => {
        setForwardRef(forwardRef + SPECIAL_ROUTE_HARACTER + activeId.split(SPECIAL_ROUTE_HARACTER)[activeId.split(SPECIAL_ROUTE_HARACTER).length - 1])
        const newId = gotoPreviousOption(activeId, SPECIAL_ROUTE_HARACTER)
        const files: FolderContentType[] | undefined = await getFiles(Directory, newId) || undefined
        updateFiles(gotoPreviousOption(activeId), files, gotoPreviousOption(title, ">"))
    }


    const onNextClick = async () => {
        const newId = forwardRef ? activeId + forwardRef : activeId
        const files: FolderContentType[] | undefined = await getFiles(Directory, newId) || undefined
        updateFiles(newId, files, gotoPreviousOption(title, ">"))
    }



    const getFiles = (data: FolderContentType[], id: string): any => {
        data.map((subData: FolderContentType) => {
            if (String(subData.id) === String(getCurrentOption(id))) {
                setFiles(subData.subOptions)
            }
            subData.subOptions && getFiles(subData.subOptions, id)
        });

    }

    useEffect(() => {
        setFiles([])
        getFiles(Directory, activeId)
    }, [activeId])

    const onSuccessfulFileClick = () => {
        getFiles(Directory, gotoPreviousOption(activeId))
    }

    const [dialog, setDialog] = useState({
        label: "",
        sourceLink: ""
    })

    const onClosedSuccessfully = () => {
        setDialog({
            label: "",
            sourceLink: ""
        })
    }

    const openDialogViewer = (sourceLink: string, label: string) => {
        setDialog({
            label: label,
            sourceLink: sourceLink
        })
    }

    const getMobileScreen = () => {
        if (getCurrentOption(activeId)) {
            return (
                <div className={classnames(Styles.container,"solid_bg")}>
                    {
                        files
                            ? (
                                files?.map((file: FolderContentType) => {
                                    return (
                                        <div className={Styles.content_container} key={file.id}>
                                            <ContentBox activeId={activeId} id={file.id} currentDirectory={title} label={file.label} contentType={file.contentType} subOptions={file.subOptions} onContentOpeneClick={updateFiles} onSuccessfulFileClick={onSuccessfulFileClick} sourceLink={file.sourceLink} openDialogViewer={openDialogViewer} />
                                        </div>
                                    )
                                })
                            )
                            : <div className={Styles.no_files}>No Files or folder</div>
                    }
                </div>
            )
        }
        else {
            return <div className={Styles.home_page}>
                <div className={Styles.title}>
                    File Manager
                <div className={Styles.label}>All the files are stored in Internal storage</div>
                </div>

                <div className={Styles.block_container}>
                    <div className={Styles.label}>Recents</div>
                    <div className={classnames(Styles.documents,"solid_bg")}>
                        <ContentBox
                                layoutType="mobileCompact" activeId={activeId} id={RESUME.id} currentDirectory={title} label={RESUME.label} contentType={RESUME.contentType} subOptions={[]} onContentOpeneClick={updateFiles} onSuccessfulFileClick={onSuccessfulFileClick} sourceLink={RESUME.sourceLink} openDialogViewer={openDialogViewer} />
                        
                    </div>
                </div>

                <div className={Styles.block_container}>
                    <div className={Styles.label}>Categories</div>
                    <div className={classnames(Styles.categ_container,"solid_bg")}>
                        <img className={Styles.categ} src={CategsIcon} />
                    </div>
                </div>
                <div className={Styles.block_container}>
                    <div className={Styles.label}>Storage</div>
                    <div className={Styles.options}><MobileOptionsList activeValue={getCurrentOption(activeId).split("_")[0]} handleOptionClick={setActiveId} onSuccessfulSubmission={onTabClicked} menuContent={Directory} /></div>
                </div>
            </div>

        }
    }

    return (
        <>
            {
                isMobile ? (
                    <BaseMobileAppContainer
                        appId={APP_KEY_IDS.MOBILE_FILE_MANAGER}
                        title={getCurrentOption(title, "optiom", ">") || "File Manager"}
                        MainMenuOptions={
                            <div className={classnames(Styles.container)}>
                                <div className={Styles.path_container}>
                                    {title}
                                </div>
                                {
                                    files
                                        ? (
                                            files?.map((file: FolderContentType,index:number) => {
                                                return (
                                                    <div className={Styles.content_container} key={file.id} >
                                                        <ContentBox activeId={activeId} id={file.id} currentDirectory={title} label={file.label} contentType={file.contentType} subOptions={file.subOptions} onContentOpeneClick={updateFiles} onSuccessfulFileClick={onSuccessfulFileClick} sourceLink={file.sourceLink} openDialogViewer={openDialogViewer} />
                                                    </div>
                                                )
                                            })
                                        )
                                        : <div className={Styles.no_files}>No Files or folder</div>
                                }
                            </div>
                        }
                        MainScreen={
                            getMobileScreen()
                        }
                        isMainScreenActive={!activeId}
                        handleBackClick={activeId  ? onPreviousClick : undefined}
                        forcedBackClickDeroute={true}
                    />
                ) : (
                    <BaseAppContainer
                        appId={APP_KEY_IDS.HOME}
                        title={title || "File Explorer"}
                        width={900}
                        height={600}
                        loadFromX={50}
                        SideBar={
                            <LeftPanelMenu activeValue={getCurrentOption(activeId).split("_")[0]} handleOptionClick={setActiveId} onSuccessfulSubmission={onTabClicked} menuContent={Directory} />
                        }
                        MainScreen={
                            <div className={Styles.container}>
                                {
                                    files
                                        ? (
                                            files?.map((file: FolderContentType) => {
                                                return (
                                                    <div className={Styles.content_container} key={file.id}>
                                                        <ContentBox activeId={activeId} id={file.id} currentDirectory={title} label={file.label} contentType={file.contentType} subOptions={file.subOptions} onContentOpeneClick={updateFiles} onSuccessfulFileClick={onSuccessfulFileClick} sourceLink={file.sourceLink} openDialogViewer={openDialogViewer} />
                                                    </div>
                                                )
                                            })
                                        )
                                        : <div className={Styles.no_files}>No Files or folder</div>
                                }
                            </div>
                        }
                        showHeader={true}
                        onClickPreviousIcon={onPreviousClick}
                        onClickNextIcon={onNextClick}
                    />
                )
            }
            {
                dialog.sourceLink && dialog.label && (
                    <ContentDialog
                        appId={"file_view"}
                        title={getCurrentOption(dialog.label, "optiom", ">")}
                        sourceLink={dialog.sourceLink}
                        fileType={FILE_EXPLORER_CONTENT_TYPE.PDF}
                        onClosedSuccessfully={onClosedSuccessfully}
                    />
                )
            }
        </>
    )
}

export default FileExplorer
